export default __webpack_public_path__ + "static/media/IMG_5341.d501e709.JPG";